var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCpu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "20px",
    width: "20px",
    id: "svg2730",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 682.7 682.7",
    style: {
      enableBackground: "new 0 0 682.7 682.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M501.3,161.3h-320c-11,0-20,9-20,20v320c0,11,9,20,20,20h320c11,0,20-9,20-20v-320C521.3,170.3,512.4,161.3,501.3,161.3z  M441.3,481.3v-60c0-11-9-20-20-20s-20,9-20,20v60h-40v-87.6l68.9-34.5c9.9-4.9,13.9-17,8.9-26.8c-4.9-9.9-17-13.9-26.8-8.9l-80,40 c-6.8,3.4-11.1,10.3-11.1,17.9v100h-120v-40h60c11,0,20-9,20-20s-9-20-20-20h-60v-200h40v60c0,11,9,20,20,20s20-9,20-20v-60h40V289 l-68.9,34.5c-9.9,4.9-13.9,17-8.9,26.8c3.5,7,10.6,11.1,17.9,11.1c3,0,6.1-0.7,8.9-2.1l80-40c6.8-3.4,11.1-10.3,11.1-17.9v-100h120 v40h-60c-11,0-20,9-20,20s9,20,20,20h60v200H441.3z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.7,281.3c11,0,20-9,20-20s-9-20-20-20h-61.3v-40h61.3c11,0,20-9,20-20s-9-20-20-20h-61.3v-60c0-11-9-20-20-20h-60V20 c0-11-9-20-20-20s-20,9-20,20v61.3h-40V20c0-11-9-20-20-20s-20,9-20,20v61.3h-40V20c0-11-9-20-20-20c-11,0-20,9-20,20v61.3h-40V20 c0-11-9-20-20-20s-20,9-20,20v61.3h-40V20c0-11-9-20-20-20s-20,9-20,20v61.3h-60c-11,0-20,9-20,20v60H20c-11,0-20,9-20,20 s9,20,20,20h61.3v40H20c-11,0-20,9-20,20s9,20,20,20h61.3v40H20c-11,0-20,9-20,20s9,20,20,20h61.3v40H20c-11,0-20,9-20,20 s9,20,20,20h61.3v40H20c-11,0-20,9-20,20s9,20,20,20h61.3v60c0,11,9,20,20,20h60v61.3c0,11,9,20,20,20s20-9,20-20v-61.3h40v61.3 c0,11,9,20,20,20s20-9,20-20v-61.3h40v61.3c0,11,9,20,20,20c11,0,20-9,20-20v-61.3h40v61.3c0,11,9,20,20,20s20-9,20-20v-61.3h40 v61.3c0,11,9,20,20,20s20-9,20-20v-61.3h60c11,0,20-9,20-20v-60h61.3c11,0,20-9,20-20s-9-20-20-20h-61.3v-40h61.3c11,0,20-9,20-20 s-9-20-20-20h-61.3v-40h61.3c11,0,20-9,20-20s-9-20-20-20h-61.3v-40H662.7z M561.3,561.3h-440v-440h440V561.3z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.6823401a.svg";
export { ForwardRef as ReactComponent };